import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/userContext.js';
import { googleRedirectCallback } from '../../api/axios';
import BaseLayout from '../../components/BaseLayout.js';
import Card from '../../components/Card.js';
import Title from '../../components/Title.js';
import { CookingPot } from '../../components/CookingSoon.js';

const GoogleRedirect = () => {
  const navigate = useNavigate();
  const { contextLogin }=useUser();
  const [error, setError] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Function to extract URL parameters
    const getQueryParams = () => {
      const params = new URLSearchParams(window.location.search);
      return {
        code: params.get('code'),  // "code" is typically provided by Google OAuth
        // state: params.get('state'),  // optional for now i guess, depends on whether we wanna do state validation
      };
    };

    const handleGoogleAuthentication = async () => {
      const { code } = getQueryParams();

      console.log("Code: ", code);

      setError('');
      
      if (!code) {
        setError("No authorization code found.");
        return;
      }

      setIsLoading(true);
      try {
        console.error("Awaiting redirect");
        const response = await googleRedirectCallback(code);
        
        // Redirect to dashboard or intended page after successful authentication
        console.log("Response: ", JSON.stringify(response));
        contextLogin(response);
        setStatusMessage("Successfully logged in!");
        setTimeout(() => {
          navigate('/dashboard');
        }, 300);
      } catch (error) {
        setError("Error during Google authentication. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    handleGoogleAuthentication();
  }, [navigate]);

  return (
    <>
        <style>
          {`
            .form-container {
            margin: 0 auto;
            padding: 0 20%;
            display: flex;
            flex-direction: column;
            padding-top: 2%;
          }

          .card-content {
            max-height: calc(100vh - 300px);
            overflow-y: auto;
            overflow-x: hidden;
            scrollbar-width: thin;
            scrollbar-color: #6B3A8F rgba(26, 26, 26, 0.5);
            padding: 10px;
          }

          .error-message {
            color: #ff4d4f;
            margin: 8px 0;
            text-align: center;
            width: 100%;
          }

          .remember-password {
            width: 100%;
            text-align: center;
          }

          .remember-password-button {
            color: #E1E1E6;
            font-family: 'Poppins', sans-serif;
            font-size: 12px;
            background: none;
            border: none;
            cursor: pointer;
          }

          .remember-password-button:hover {
            color: #9797FA;
          }

          .status-message {
            width: 100%;
            color: #E1E1E6;
            text-align: center;
            font-family: 'Poppins', sans-serif;
            font-size: 12px;
            font-style: normal;
            font-weight: 300;
            line-height: 140%;
            margin-top: 16px;
          }
          `}
        </style>
        <BaseLayout>
          <div className="form-container">
            <Card>
              <div className="card-content">
                <Title text="Sign In with Google"/>
                <div className="status-message">
                  {isLoading ? (
                    <div style={{marginTop: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
                      <CookingPot />
                      <p style={{marginTop: '16px', textAlign: 'center'}}>Please wait while we complete your sign-in</p>
                    </div>
                  ) : (
                    statusMessage ? (
                      <div className="status-message">
                        {statusMessage}
                      </div>
                    ) : error && (
                      <div className="error-message">{error}</div>
                    )
                  )}
                </div>
              </div>
            </Card>
          </div>
        </BaseLayout>
      </>
  );
};

export default GoogleRedirect;
